import React, { useEffect, useState } from "react";
import CareersRegisterOtpVerify from "./CareersRegisterOtpVerify";
import CareersRegisterInputOtp from "./CareersRegisterInputOtp";
import CareersRegisterInputEmail from "./CareersRegisterInputEmail";
import CareersRegisterInputMobile from "../registration/CareersRegisterInputMobile";
import Cookies from "universal-cookie";
import { createCurrentUrl, getAbsoluteDestinationUrl, certificationPage, deviceType } from "../../utils/registrationUtils";
import {
  postLoginData,
  clearUserLoginSignupOtpResponse,
  getUserAuthenticationEmail
} from "../../../store/slices/Registration/CommonSlices";
import { connect } from "react-redux";
import ReactGA from "react-ga";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios from "axios";
import DataLayerEvents from "../common/DataLayerEvents";
import {gaEvent, gaLocationAndContentData} from "../../utils/index";

function CareersRegisterOtpVerifyScreen(props) {
  const [step, setStep] = useState(1);
  const [showSuccessCard, setShowSuccessCard] = useState(false);
  const [isMobileFocused, setIsMobileFocused] = useState(false);
  const [isEmailFocused, setIsEmailFocused] = useState(false);
  const [isEmailSubmit, setIsEmailSubmit] = useState(false);
  const cookies = new Cookies();
  const [resendTimer, setResendTimer] = useState(0); // Initial timer value in seconds
  const [isResending, setIsResending] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [remainingSeconds, setRemainingSeconds] = useState(Math.abs(localStorage.getItem("remainingSeconds") ? Math.abs(30 - Math.abs(localStorage.getItem("remainingSeconds") - new Date().getSeconds())) : 0));
  const [errorToaster, setErrorToaster] = useState(false); // set error for duplicate 
  
  const location = useLocation();
  const destinationDomain = axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME;
  //to check correct current url
  const subDomainName = window.location.host?.split(".")[0];
  const urlCheck = window.location.href;
  let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
   window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);
  const urls = ["/user/login", "/user/complete-profile", "/user/register", "/user/otp-verify", "/user/update-profile", "user/login/otp-verify"];
  const currentDeferrerUrl = document.referrer
  const currentCookieUrl = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
  const isMatch = urls.some(path => currentDeferrerUrl?.includes(path));
  const currentUrl = isMatch ? currentCookieUrl : currentDeferrerUrl;
  const urlObj = currentUrl ? new URL(currentUrl) : null;
  const cleanUrl = urlObj ? `${urlObj.origin}${urlObj.pathname}` : null;
  const sourseDestination = cleanUrl ? `${cleanUrl}${window.location.search}` : getAbsoluteDestinationUrl();
  
  //-----------------------------

  useEffect(() => {
    // browser back button check
    window.history.pushState(null, "", window.location.href);
    const handlePopstate = (event) => {
    props.setFormCurrentState({});
    window.location.href = `/user/register${window.location.search}`;
  };
    window.onpopstate = handlePopstate;
    
    // state false on redirect
    props.setReloadFlag(false);
    let timeout;
    const resetTimeout = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => setIsActive(false), 900000); // 15 minutes
    };
    const handleActivity = () => {
      setIsActive(true);
      resetTimeout();
    };
    if (deviceType == "web") {
      // Set up event listeners
      window.addEventListener('click', handleActivity);
      window.addEventListener('keydown', handleActivity); // Adding key press event
    } else {
      // Set up event listeners
      window.addEventListener('scroll', handleActivity);
      window.addEventListener('click', handleActivity);
      window.addEventListener('touchstart', handleActivity);
      window.addEventListener('touchmove', handleActivity);
      window.addEventListener('keydown', handleActivity);
    }
    // Set up initial timeout
    resetTimeout();

    return () => {
      window.onpopstate = handlePopstate; // Clean up the event handler
      if (deviceType == "web") {
        window.removeEventListener('click', handleActivity);
        window.removeEventListener('keydown', handleActivity);
      } else {
        window.removeEventListener('scroll', handleActivity);
        window.removeEventListener('click', handleActivity);
        window.removeEventListener('touchstart', handleActivity);
        window.removeEventListener('touchmove', handleActivity);
        window.removeEventListener('keydown', handleActivity);
      }
      clearTimeout(timeout);
    }
  }, []);

  useEffect(() => {
    if (!isActive && window.location.pathname.includes("user/otp-verify")) {
      window.location.href = `/user/register${window.location.search}`;
      props.setFormCurrentState({});
    }
  }, [isActive])

  useEffect(() => {
    if (window.location.pathname.includes('user/otp-verify')) {
      props.setRemoveTab(true)
    }
    if (cookies.get("registrationState")?.currentScreen?.screen === 3) {
      let registrationData = cookies.get("registrationState")?.formValues
      setStep(2);
      const destinationUrl = getAbsoluteDestinationUrl() || createCurrentUrl();
      let params = {};
      params.current_url = window.location.href;
      params.page_url = sourseDestination;
      params.destination = destinationUrl;
      params.country_code = "+91";
      params.cta_clicked = "signup",
        params.mobile_number = props.values.mobile || registrationData?.mobile;
      params.mobile_otp_verify = true;
      if(props.formCurrentState?.isEmailEditing ? false : true)
        params.email = props.values.email || registrationData?.email;
      if (props.postSignupData) {
        params.user_uuid = props.postSignupData?.user_uuid;
      }
      props.dispatch(postLoginData(params));
    }
    if (cookies.get("registrationState")?.otp_timer > 1) {
      setResendTimer(cookies.get("registrationState")?.otp_timer)
      setIsResending(true)
      resetTimer()
    }
  }, [])

  // to show sent otp success card only for 5 sec.
  useEffect(() => {
    if (props.usersLoginSignupOtp) {
      if(props.usersLoginSignupOtp?.otp_on == "mobile"){
       gaEvent("otpmobilesendotpsignup", "login_signup", `${gaLocationAndContentData}`, "");
      }else {
       gaEvent("otpemailsendotpsignup", "login_signup", `${gaLocationAndContentData}`, "");
      }
      setIsEmailSubmit(false);
      setResendTimer(30)
      resetTimer()
      setShowSuccessCard(true);
      const timeout = setTimeout(() => {
        setShowSuccessCard(false);
      }, 5000);
      return () => clearTimeout(timeout);
    }
  }, [props.usersLoginSignupOtp]);

  // Email otp screen 
  useEffect(() => {
    if(props.loginDatas){
      setErrorToaster(false);
    }
    if (props.loginDatas?.required_field?.includes("email") ||
      props.loginDatas?.required_field?.includes("email_otp")) {
      setStep(2);
      props.setFormCurrentState((prev) => ({
        ...prev, currentScreen: {
          ...prev.currentScreen,
          screen: 3
        }
      }))
    }
    if (props.loginDatas?.required_field?.includes("email_otp")) {
      if (!props.formCurrentState?.isEmailEditing && cookies.get("registrationState")?.currentScreen?.screen == 2) {
        props.otpGetClickedEmail();
      }else if(props.formCurrentState?.isEmailEditing && isEmailSubmit){
        props.otpGetClickedEmail();
      }
    }
  }, [props.loginDatas])

  useEffect(() => {
    if (props.formikValues?.otp?.length == 4 && step == 1)
      props.otpSubmitMobile();
    if (props.formikValues?.otp?.length == 4 && step == 2){
      props.otpSubmitEmail();
    }
  }, [props.formikValues?.otp])

  useEffect(() => {
    if (step == 2) {
      gaEvent("otpmobileverifysignup", "login_signup", `${gaLocationAndContentData}`, "");
      props.setFieldValue("otp", "")
      props.setFormikValues((prev) => ({ ...prev, "otp": "" }))
      props.setReinitialize(true)
      setTimeout(() => props.setReinitialize(false), 50);
    }
  }, [step == 2])

  useEffect(() => {
    if(props.usersLoginSignupOtpError?.block_user_case === "try_again"){
      setIsEmailSubmit(false);
      const totalRemainingSecs = props.usersLoginSignupOtpError?.available_in?.split(" ")?.[0];
      setRemainingSeconds(totalRemainingSecs);
      const currentTime = new Date();
      const currentSeconds = currentTime.getSeconds();
      localStorage.setItem("remainingSeconds", currentSeconds);
    }
  },[props.usersLoginSignupOtpError])
// to hide email-otp field
  useEffect(() => {
    if (props.userAuthenticationEmailError) {
      props.setEditEmail(true);
      props.setFormCurrentState((prev) => ({
        ...prev, isEmailEditing: true
      }))
    }
  }, [props.userAuthenticationEmailError])

  // popup added for duplicate user
  useEffect(() => {
    if(props.loginDatasError?.duplicate_user){
        setErrorToaster(true);
        const timeout = setTimeout(() => {
              setErrorToaster(false);
              props.setFormCurrentState({});
              cookies.remove("loginState", {
                  path: "/",
                  domain: destinationDomain,
              });
             window.location.href = `/user/login${window.location.search}`;
            }, 2000);
            return () => clearTimeout(timeout);
          }
  }, [props.loginDatasError])

  const resetTimer = () => {
      setRemainingSeconds(30);
      const currentTime = new Date();
      const currentSeconds = currentTime.getSeconds();
      localStorage.setItem("remainingSeconds", currentSeconds);    
  };
  
  const fieldsAndCtasConditions = {
    stepOneMobileField : props.usersAuthenticationError?.authorization == false || props.usersLoginSignupOtpError,
    stepOneInputOtp : (!props.editMobile && !props.formCurrentState?.isMobileEditing && props.usersAuthentication?.authorization && !props.usersLoginSignupOtpError) || props.usersLoginSignupOtpError?.block_user_case === "try_again",
    stepOneSubmitButton: props.editMobile || props.formCurrentState?.isMobileEditing || props.usersAuthenticationError?.authorization == false || (props.usersLoginSignupOtpError && props.usersLoginSignupOtpError?.block_user_case !== "try_again"),
    stepOneSubmitButtonDisable: props.values?.mobile && !props.errors?.mobile && (props.usersAuthentication?.authorization ||  props.usersLoginSignupOtp) && props.userAccountLimitCheck?.authorization,
    stepTwoEmailField : props.userAuthenticationEmailError?.authorization == false || props.usersLoginSignupOtpError,
    stepTwoInputOtp : (!props.editEmail && !props.formCurrentState?.isEmailEditing && (props.userAuthenticationEmail?.authorization || props.usersLoginSignupOtp)) || props.usersLoginSignupOtpError?.block_user_case === "try_again",
    stepTwoGetOtpButton : props.editEmail || props.formCurrentState?.isEmailEditing || props.userAuthenticationEmailError?.authorization == false || (props.usersLoginSignupOtpError && props.usersLoginSignupOtpError?.block_user_case !== "try_again"),
    stepTwoGetOtpButtonDisable: props.values?.email && !props.errors?.email && (props.userAuthenticationEmail?.authorization || props.usersLoginSignupOtp)
  }

  return (
    <>
       <DataLayerEvents contentType={"Login/Signup"} pageTypes={"signup_otp_verify"} verticalName={props.domain?.domain}/> 
      <>{step == 1 &&
        <><h1 className="careers_register_otp_heading">OTP Verification</h1>
          {deviceType == "web" ?
            (deviceType == "web" || fieldsAndCtasConditions?.stepOneMobileField) &&
            <CareersRegisterOtpVerify
              values={props.values}
              setFieldValue={props.setFieldValue}
              errors={props.errors}
              touched={props.touched}
              handleBlur={props.handleBlur}
              geolocationData={props.geolocationData}
              otpSubmitMobile={() => props.otpSubmitMobile()}
              setEditMobile={props.setEditMobile}
              editMobile={props.editMobile}
              setIsMobileFocused={setIsMobileFocused}
              loginDatas={props.loginDatas}
              updateTouchedFields={props.updateTouchedFields}
              setFormCurrentState={props.setFormCurrentState}
              formCurrentState={props.formCurrentState}
              usersAuthentication={props.usersAuthentication}
              usersLoginSignupOtpError={props.usersLoginSignupOtpError}
              setShowSuccessCard={setShowSuccessCard}
              setSyncSignupValues={props.setSyncSignupValues}
            /> :
            (deviceType == "mobile" || fieldsAndCtasConditions?.stepOneMobileField) &&
            <CareersRegisterInputMobile
              handleChange={props.handleChange}
              setFieldValue={props.setFieldValue}
              values={props.values}
              errors={props.errors}
              touched={props.touched}
              handleBlur={props.handleBlur}
              geolocationData={props.geolocationData}
              otpGetClicked={() => props.otpSubmitMobile()}
              loginDatas={props.loginDatas}
              otpVerifyClicked={props.otpVerifyClicked}
              setEditMobile={props.setEditMobile}
              editMobile={props.editMobile}
              setIsMobileFocused={setIsMobileFocused}
              postSignupData={props.postSignupData}
              updateTouchedFields={props.updateTouchedFields}
              setFormCurrentState={props.setFormCurrentState}
              formCurrentState={props.formCurrentState}
              setSyncSignupValues={props.setSyncSignupValues}
              setReinitialize={props.setReinitialize}
            />}
          
          {fieldsAndCtasConditions?.stepOneInputOtp &&
            <CareersRegisterInputOtp
              values={props.values}
              name={"otp"}
              setFieldValue={props.setFieldValue}
              errors={props.errors}
              touched={props.touched}
              handleBlur={props.handleBlur}
              otpGetClicked={() => props.otpGetClickedMobile()}
              otpSubmitMobile={() => props.otpSubmitMobile()}
              step={step}
              loginDatas={props.loginDatas}
              setFormCurrentState={props.setFormCurrentState}
              formCurrentState={props.formCurrentState}
              component={"phone"}
              screen={"signup"}
              setResendTimer={setResendTimer}
              resendTimer={resendTimer}
              setIsResending={setIsResending}
              isResending={isResending}
              remainingSeconds={remainingSeconds}
              setRemainingSeconds={setRemainingSeconds}
              resetTimer={resetTimer}
              setReinitialize={props.setReinitialize}
              setFormikValues={props.setFormikValues}
            />}
            

          {/* {props.loginDatasLoading && <p>Verifying Mobile OTP</p>} */}
          <div className="careers_register_fixed_mobile">
            {fieldsAndCtasConditions?.stepOneInputOtp && 
            <button
                type="submit"
                disabled={(props.formikValues?.otp?.length != 4 || props.loginDatas?.otp_response == false || props.loginDataLoading) ? true : false}
                className={props.formikValues?.otp?.length >= 4 ?
                  "careers_register_valid_button careers_register_button"
                  : "careers_register_button"}
                onClick={() => {
                  props.otpSubmitMobile()
                  // resetTimer()
                }}
              >
                Verify OTP
              </button>}
          </div>
          {showSuccessCard && !props.editMobile &&
            <div className="success_card">
              OTP sucessfully sent to this mobile number.
            </div>
          }
          {fieldsAndCtasConditions?.stepOneSubmitButton && 
          <button
              type="submit"
              disabled={fieldsAndCtasConditions?.stepOneSubmitButtonDisable ? false : true}
              className={fieldsAndCtasConditions?.stepOneSubmitButtonDisable ?
                "careers_register_valid_button careers_register_button career_register_button_margin"
                : "careers_register_button career_register_button_margin"}
              onClick={() => {
                props.setFormCurrentState((prev) => ({ ...prev, otp_timer: null }))
                setResendTimer(30)
                props.otpGetClickedMobile();
                resetTimer()
                props.dispatch(clearUserLoginSignupOtpResponse())
              }}
            >
              Submit
            </button>}
        </>}

      {step == 2 &&
        <><h1 className="careers_register_otp_heading">Email Verification</h1>
          {(step == 2 || fieldsAndCtasConditions?.stepTwoEmailField) &&
            <CareersRegisterInputEmail
              name={"email"}
              values={props.values}
              setFieldValue={props.setFieldValue}
              errors={props.errors}
              touched={props.touched}
              handleBlur={props.handleBlur}
              geolocationData={props.geolocationData}
              otpSubmitEmail={() => props.otpSubmitEmail()}
              loginDatas={props.loginDatas}
              setEditEmail={props.setEditEmail}
              editEmail={props.editEmail}
              setIsEmailFocused={setIsEmailFocused}
              updateTouchedFields={props.updateTouchedFields}
              setFormCurrentState={props.setFormCurrentState}
              formCurrentState={props.formCurrentState}
              setSyncSignupValues={props.setSyncSignupValues}
              setTouched={props.setTouched}
            />
          }
          {/* {props.loginDatas?.required_field?.includes("email_otp") &&  */}
          {fieldsAndCtasConditions?.stepTwoInputOtp &&
            <CareersRegisterInputOtp
              values={props.values}
              setFieldValue={props.setFieldValue}
              errors={props.errors}
              touched={props.touched}
              handleBlur={props.handleBlur}
              otpGetClicked={() => props.otpGetClickedEmail()}
              name={"otp"}
              step={step}
              loginDatas={props.loginDatas}
              component={"phone"}
              screen={"signup"}
              setResendTimer={setResendTimer}
              resendTimer={resendTimer}
              setIsResending={setIsResending}
              isResending={isResending}
              setFormCurrentState={props.setFormCurrentState}
              remainingSeconds={remainingSeconds}
              setRemainingSeconds={setRemainingSeconds}
              resetTimer={resetTimer}
              setReinitialize={props.setReinitialize}
              setFormikValues={props.setFormikValues}
            />}
          
          <div className="careers_register_fixed_mobile">
            {fieldsAndCtasConditions?.stepTwoInputOtp &&
              <button
                type="submit"
                disabled={(props.formikValues?.otp?.length != 4 || props.loginDatas?.otp_response == false || props.loginDataLoading) ? true : false}
                className={props.formikValues?.otp?.length >= 4 ?
                  "careers_register_valid_button careers_register_button"
                  : "careers_register_button"}
                onClick={() => {
                  props.otpSubmitEmail()
                  resetTimer()
                }
                }
              >
                Verify Email
              </button>}
          </div>
          {/* } */}
          {fieldsAndCtasConditions?.stepTwoGetOtpButton && <button
              type="submit"
              disabled={fieldsAndCtasConditions?.stepTwoGetOtpButtonDisable ? false : true}
              className={fieldsAndCtasConditions?.stepTwoGetOtpButtonDisable ?
                "careers_register_valid_button careers_register_button career_register_button_margin"
                : "careers_register_button career_register_button_margin"}
              onClick={() => {
                props.setFormCurrentState((prev) => ({ ...prev, otp_timer: null }))
                setResendTimer(30)
                // resetTimer()
                // props.otpGetClickedEmail();
                props.otpSubmitEmail();
                setIsEmailSubmit(true);
              }}
            >
              Submit
            </button>}
          {showSuccessCard && !props.editEmail &&
            <div className="success_card">
              OTP sucessfully sent to this Email-ID.
            </div>
          }
          {errorToaster && <div className="success_card">Something went wrong..please try login again.</div>}

        </>
      }
     </>
    </>

  );
}
const mapStateToProps = (state) => {
  return {
    loginDatasError: state.usersCommonData?.loginDataError,
    loginDataLoading: state.usersCommonData?.loginDataLoading,
    usersLoginSignupOtpError: state.usersCommonData?.userLoginSignupOtpError,
    usersLoginSignupOtp: state.usersCommonData?.userLoginSignupOtp,
    usersAuthentication: state.usersCommonData?.userAuthentication,
    usersAuthenticationError: state.usersCommonData?.userAuthenticationError,
    userAuthenticationEmail: state.usersCommonData?.userAuthenticationEmail,
    userAuthenticationEmailError: state.usersCommonData?.userAuthenticationEmailError,
    userAccountLimitCheck: state.usersCommonData?.userAccountLimit,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CareersRegisterOtpVerifyScreen);
